import {graphql} from 'gatsby';
import React, {Fragment, memo} from 'react';

import * as iter from '../utils/iter';
import Prng from '../utils/prng';

import PageElement from './page-element';

export const query = graphql `
	fragment PageElementGroup on PagesJson {
		content {
			__typename
			... on PageContentGroups {
				elementGroups {
					name
					elements {
						...PageElementFrag
					}
				}
			}
		}
	}
`;

export default memo(
	/**
	 * @param {{
	 *   name: string,
	 *   nodes: Array<import("../../tmp/graphql-types").PageElementGroupFragment>,
	 *   meta: import("../page-metadata").PageMetadata,
	 *   hashState: number,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function PageElementGroup({name, nodes, meta, hashState}) {
		const prng = new Prng(hashState);

		if (nodes[0]?.content?.__typename !== 'PageContentGroups') {
			return null;
		}

		const {done, value: group} = iter.from(nodes[0].content.elementGroups)
			.filter((g) => g.name === name)
			.next();
		if (done === true || group.elements.length === 0) {
			return null;
		}

		return (
			<Fragment>
				{group.elements.map((element, i) => (
					<PageElement
						key={i}
						meta={meta}
						element={element}
						hashState={prng.next()}
					/>
				))}
			</Fragment>
		);
	}
);
